import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from 'appStore/store';
import config from 'config';

export interface CustomResponse<TData = unknown> {
  data: TData;
  messages?: Record<string, string>;
}

const baseQuery = fetchBaseQuery({
  baseUrl: config.REACT_APP_API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).session.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const restApi = createApi({
  reducerPath: 'restApi',
  baseQuery,
  tagTypes: ['changeRequest', 'messengerMessages', 'outage'],
  endpoints: builder => ({}),
});
